import makeStyles from "@mui/styles/makeStyles";
import { createTheme } from "@mui/material";
const theme = createTheme();

export const useAddActivityStyles = makeStyles(() => ({

}));
